import React, { useMemo, useState } from 'react';
import { useVehicles } from '../../../context/VehiclesContext';
import { IconCamera } from '../../ui/Icons';

const SimilarCardImage = ({ src, alt }) => {
  const [failed, setFailed] = useState(false);
  if (failed || !src) {
    return (
      <div className="similar-image-placeholder">
        <IconCamera />
      </div>
    );
  }
  return <img src={src} alt={alt} onError={() => setFailed(true)} />;
};

const SimilarVehicles = ({ currentVehicle, onViewDetails }) => {
  const { vehicles: allVehicles } = useVehicles();

  const similar = useMemo(() => {
    if (!currentVehicle) return allVehicles.slice(0, 3);

    const sameMake = allVehicles.filter(
      (v) => v.id !== currentVehicle.id && v.make === currentVehicle.make
    );
    const sameBody = allVehicles.filter(
      (v) =>
        v.id !== currentVehicle.id &&
        v.bodyType === currentVehicle.bodyType &&
        v.make !== currentVehicle.make
    );

    return [...sameMake, ...sameBody].slice(0, 3);
  }, [currentVehicle, allVehicles]);

  if (similar.length === 0) return null;

  return (
    <div className="similar-vehicles">
      <h3>Similar Vehicles</h3>
      <div className="similar-grid">
        {similar.map((car) => (
          <div
            key={car.id}
            className="similar-card"
            onClick={() => onViewDetails && onViewDetails(car)}
          >
            <SimilarCardImage src={car.image} alt={car.title} />
            <div className="similar-info">
              <h4>{car.title}</h4>
              <p>
                {car.year} • {car.mileage.toLocaleString()} miles
              </p>
              <span className="similar-price">£{car.price.toLocaleString()}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SimilarVehicles;
